/* ---------------------------------------
   Helpers
--------------------------------------- */
function getRangeEta(minDays = 3, maxDays = 5) {
  const start = new Date();
  start.setDate(start.getDate() + minDays);

  const end = new Date();
  end.setDate(end.getDate() + maxDays);

  const opts = { weekday: 'short', month: 'short', day: 'numeric' };

  return `🚚 Get it by ${start.toLocaleDateString('en-US', opts)} – ${end.toLocaleDateString('en-US', opts)}`;
}

/* ---------------------------------------
   Input Handler (numbers only + button toggle)
--------------------------------------- */
function handlePincodeInput(input) {
  input.value = input.value.replace(/\D/g, '');

  const button = document.getElementById('pincode-action-btn');
  button.disabled = input.value.length === 0 || input.disabled;
}

/* ---------------------------------------
   Button Toggle
--------------------------------------- */
function handlePincodeAction() {
  const btn = document.getElementById('pincode-action-btn');
  btn.innerText === 'Check' ? checkDeliveryPincode() : resetPincode();
}

function resetPincode() {
  const input = document.getElementById('delivery-pincode');
  const button = document.getElementById('pincode-action-btn');

  input.disabled = false;
  input.value = '';
  input.focus();

  button.innerText = 'Check';
  button.disabled = true;

  ['delivery-msg', 'cod-msg', 'return-msg'].forEach(id => {
    document.getElementById(id).style.display = 'none';
  });
}

/* ---------------------------------------
   Main Logic
--------------------------------------- */
async function checkDeliveryPincode() {
  const wrapper = document.querySelector('.delivery-options');
  const nonServiceable = JSON.parse(wrapper.dataset.nonServiceable);
  const nonCOD = JSON.parse(wrapper.dataset.nonCod);

  const input = document.getElementById('delivery-pincode');
  const btn = document.getElementById('pincode-action-btn');
  const deliveryMsg = document.getElementById('delivery-msg');
  const codMsg = document.getElementById('cod-msg');
  const returnMsg = document.getElementById('return-msg');

  const pincode = input.value.trim();

  /* Regex validation */
  if (!/^[1-9][0-9]{5}$/.test(pincode)) {
    deliveryMsg.innerHTML = '❌ Please enter a valid 6-digit pincode';
    deliveryMsg.className = 'msg error';
    deliveryMsg.style.display = 'block';
    return;
  }

  /* Non-serviceable */
  if (nonServiceable.includes(pincode)) {
    deliveryMsg.innerHTML = '❌ Delivery is not available at this pincode';
    deliveryMsg.className = 'msg error';
    deliveryMsg.style.display = 'block';
    return;
  }

  /* India Post API validation */
  let apiResponse = null;

  try {
    const res = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
    apiResponse = await res.json();
  } catch (e) {}

  if (!apiResponse || apiResponse[0]?.Status !== 'Success') {
    deliveryMsg.innerHTML = '❌ Please enter a valid 6-digit pincode';
    deliveryMsg.className = 'msg error';
    deliveryMsg.style.display = 'block';
    codMsg.style.display = 'none';
    returnMsg.style.display = 'none';
    return;
  }

  /* Success */
  deliveryMsg.innerHTML = getRangeEta(3, 5);
  deliveryMsg.className = 'msg success';
  deliveryMsg.style.display = 'block';

  codMsg.innerHTML = nonCOD.includes(pincode)
    ? '💰 Cash on delivery is not available'
    : '💰 Cash on delivery is available';

  codMsg.className = nonCOD.includes(pincode) ? 'msg error' : 'msg success';
  codMsg.style.display = 'block';

  returnMsg.style.display = 'block';

  /* Lock */
  input.disabled = true;
  btn.innerText = 'Change';
  btn.disabled = false;
}
